var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer",attrs:{"app":"","color":"white","absolute":""}},[_c('div',{staticClass:"mx-auto"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logofooter.png"),"alt":"logofooter"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }